import { ADD_GL_GROUP, DELETE_GL_GROUP, GET_GL_GROUPS, UPDATE_GL_GROUP } from "../types";


const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_GL_GROUPS:
            return {...state, list: payload};

        case UPDATE_GL_GROUP:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload.id ? payload : item
                ),
            };

        case ADD_GL_GROUP:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_GL_GROUP:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
